import { Component } from "preact";
import style from "./style";

class CommonHeader extends Component {
  render() {
    const { active, title } = this.props;
    return (
      <div className={style.mainWrapper}>
        <div className={style.headerNavbarWrapper}>
          <div>
            <img
              src="/static/assets/images/home_logo.png"
              alt="United Nations"
            />
          </div>
          <div>
            <ul>
              <li
                style={{ cursor: "pointer" }}
                onClick={() => {
                  location.pathname = "/";
                }}
              >
                <a>Home</a>
              </li>
              <li>
                <a
                  className={
                    active === "projects" ? style.headerActiveLink : undefined
                  }
                  alt="Activities"
                  href="/projects"
                >
                  Activities
                </a>
              </li>
              <li>
                <a
                  className={
                    active === "donors" ? style.headerActiveLink : undefined
                  }
                  alt="Donors"
                  href="/donors"
                >
                  Donors
                </a>
              </li>
              <li style={{ display: "none" }}>
                <a
                  className={
                    active === "activities" ? style.headerActiveLink : undefined
                  }
                  alt="Fields of operations"
                  href="#"
                >
                  Fields of operations
                </a>
              </li>
              <li>
                <a
                  className={
                    active === "sdg" ? style.headerActiveLink : undefined
                  }
                  alt="Sectors"
                  href="/sustainable-development-goals"
                >
                  Sectors
                </a>
              </li>
            </ul>
          </div>
          <div style={{ display: "none" }}>
            <button>
              <i className="fas fa-search" />
            </button>
          </div>
        </div>
        <div className={style.headerWrapper}>
          <span>{title}</span>
        </div>
      </div>
    );
  }
}

export default CommonHeader;



// WEBPACK FOOTER //
// ./components/commonHeader/index.js